import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { map } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { NotFoundComponent } from '../../../shared/components/not-found/not-found.component';
import { WebsiteFooterComponent } from '../../../shared/components/website-footer/website-footer.component';
import { WebsiteHeaderComponent } from '../../../shared/components/website-header/website-header.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokCta, StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { PreFooterComponent } from '../pre-footer/pre-footer.component';
import { TopGradientComponent } from '../top-gradient/top-gradient.component';

@Component({
  selector: 'app-storyblok-root',
  imports: [
    StoryblokDirective,
    DynamicComponent,
    DynamicIoDirective,
    WebsiteHeaderComponent,
    PreFooterComponent,
    RouterLink,
    ButtonDirective,
    WebsiteFooterComponent,
    NotFoundComponent,
    TopGradientComponent,
    StoryblokCdnPipe,
  ],
  templateUrl: './storyblok-root.component.html',
  styleUrls: ['./storyblok-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class StoryblokRootComponent {
  private route = inject(ActivatedRoute);
  public storyblokService = inject(PICFLOW_STORYBLOK);
  @Input({ required: true }) story: ISbStoryData;
  @Input({ required: true }) darkHeader: boolean;
  @Input({ required: true }) prefooter: {
    cta: StoryblokCta[];
    _uid: string;
    image: StoryblokImage;
    component: 'preFooter';
    _editable: string;
  };
  @Input({ required: true }) hasHomeTeaser: boolean;
  @Input({ required: true }) hasShowcaseTeaser: boolean;
  @Input({ required: true }) blurOverlay: StoryblokImage;
  @Input({ required: true }) topBlur: StoryblokImage;
  @Input({ required: true }) topBlurMaxHeight: number;
  @Input({ required: true }) verticalDottedLines: boolean;
  @Input() extraDataMap: Map<string, { [key: string]: unknown }>;
  @Input() hideHeaderNav: boolean;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Input() customCta: 'contact' | undefined;

  allowStickyHeader = toSignal(this.route.data.pipe(map(data => data?.allowStickyHeader ?? true)));

  dynamicInputs(values: { [key: string]: unknown }) {
    const data = { ...values };
    const extraData = this.extraDataMap?.get((values as { component: string }).component);
    if (extraData) {
      for (const key of Object.keys(extraData)) data[key] = extraData[key];
    }
    return data;
  }
}
